export const getBranding = () => {
  return Promise.resolve({
    partnerLogo:
      "https://www.collegewell.com/wp-content/themes/collegewell_custom_theme2022/public/images/logo.svg",
    primary: "#2b3d42",
    title: "CollegeWell",
  });
};

export function getTenantFromHash() {
  const url = new URL(window.location.href);
  const hostname = url.hostname;

  const parts = hostname.split(".")[0];

  if (
    parts === "www" ||
    parts === "app" ||
    parts === "localhost" ||
    parts === "127"
  ) {
    return null;
  }

  return parts;
}

const hexToRgb = (hex?: string) => {
  if (!hex) return null;
  const sanitized = hex.replace("#", "");
  const full =
    sanitized.length === 3
      ? sanitized
          .split("")
          .map((c) => c + c)
          .join("")
      : sanitized;
  const int = parseInt(full, 16);
  return {
    r: (int >> 16) & 255,
    g: (int >> 8) & 255,
    b: int & 255,
  };
};

export const lightenHex = (hex?: string, weight = 0.8) => {
  const rgb = hexToRgb(hex);
  if (!rgb) return "#EEFCFC";
  const r = Math.round(rgb.r + (255 - rgb.r) * weight);
  const g = Math.round(rgb.g + (255 - rgb.g) * weight);
  const b = Math.round(rgb.b + (255 - rgb.b) * weight);
  return `rgb(${r}, ${g}, ${b})`;
};
